import styled, { css } from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";

export const InnerBlockContainer = styled.div`
  padding: ${({ padding, narrowText }) =>
    narrowText ? "0" : padding ? padding : "0 1rem"};
  margin: ${({ margin }) => (margin ? margin : "0 auto")};
  max-width: ${({ maxWidth, theme }) =>
    maxWidth ? maxWidth : theme.grid.outer};
`;

export const InnerNarrowBlockContainer = styled.div`
  margin: ${({ margin, centerContent }) =>
    centerContent ? "0 auto" : margin ? margin : "0"};
  padding-left: ${({ centerContent }) => (centerContent ? "1rem" : "6rem")};
  max-width: ${({ maxWidth, theme, narrowText, centerContent }) =>
    narrowText
      ? centerContent
        ? "80%"
        : "65%"
      : maxWidth
      ? maxWidth
      : theme.grid.outer};

  ${media.lessThan(breakpoints.ipad)`
    max-width: 100%;
    padding-right: 1rem;
  `}
  ${({ useSmall, narrowText }) =>
    narrowText &&
    useSmall &&
    css`
      padding-left: 0;
      ${media.lessThan(breakpoints.mobile)`
        padding-left: 0;
        padding-right: 0;
        max-width: 100%;
      `}
    `}
`;

export const InnerNarrowBlockContentContainer = styled.div`
  max-width: ${({ maxWidth, theme, narrowText }) =>
    narrowText ? "85%" : maxWidth ? maxWidth : theme.grid.outer};
  ${media.lessThan(breakpoints.mobile)`
    max-width: 100%;
  `}
  ${({ useSmall, narrowText }) =>
    narrowText &&
    useSmall &&
    css`
      max-width: 74%;
      padding-left: 11%;
      ${media.lessThan(breakpoints.ipad)`
        padding-left: 7%;
        max-width: 74%;
      `}
      ${media.lessThan(breakpoints.mobile)`
        padding-left: 0;
        max-width: 100%;
      `}
    `}
`;
